import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useCompareOpportunitiesMutation, useCreateUpdateSpecificationExceptionMutation, useGetAcceptedSaledInfoByIdQuery, useGetAllActiveUsersQuery, useGetAllProjectNotesQuery, useGetContactLookupQuery, useGetDrcSignReviewSurveyDetailsQuery, useGetEcdReviewSurveyDetailsQuery, useGetjobScopeDetailsByIdQuery, useGetPccReviewSurveyDetailsQuery, useGetPermitByIdQuery, useGetSaleInfoByIdQuery, useGetSpecReasonQuery, useLazyGetAllProjectNotesQuery, useLazyGetContactDetailsInProjectQuery, useLazyGetEcdReviewSurveyDetailsQuery, useLazyGetSaleInfoByIdQuery, useSendEmailAfterActionMutation, useUpdateContactDetailsInProjectMutation, useUpdateProjectActionsMutation, useUpsertAcceptedSaleInfoDetailsMutation, useUpsertDrcSignReviewSurveyMutation, useUpsertECDReviewSurveyMutation, useUpsertJobScopeMutation, useUpsertOpportunityDetailsMutation, useUpsertPccReviewSurveyMutation, useUpsertprojectPermitDetailsMutation, useUpsertPromoteToSwMutation, useUpsertSaleInfoDetailsMutation, useUpsertSpecReviewMutation } from '../../../../services/EndPointsApis';
import DetailsPOHWizardData from '../PutOnHoldWizardData/DetailsPOHWizardData';
import DocumentPOHWizardData from '../PutOnHoldWizardData/DocumentPOHWizardData';
import SummaryPOHWizardData from '../PutOnHoldWizardData/SummaryPOHWizardData';
import DetailsResumeWizardData from '../ResumeWizard/DetailsResumeWizardData';
import DocumentResumeWizardData from '../ResumeWizard/DocumentResumeWizardData';
import SummaryResumeWizardData from '../ResumeWizard/SummaryResumeWizardData';
import AddressesWizardData from '../SaleWizardData/AddressesWizardData';
import ContactWizardData from '../SaleWizardData/ContactWizardData';
import DocumentWizardData from '../SaleWizardData/DocumentWizardData';
import { initialValuesPromoteToSw, initialValuesSale } from '../SaleWizardData/InitialValuesSalesWizard';
import NotesWizardData from '../SaleWizardData/NotesWizardData';
import { initialValuesOpportunities } from '../SaleWizardData/OpportunityWizard/InitialValuesOpportunities';
import OpportunityDetailsWizard from '../SaleWizardData/OpportunityWizard/OpportunityDetailsWizard';
import SalesInfoWizardData from '../SaleWizardData/SalesInfoWizardData';
import SummaryWizardData from '../SaleWizardData/SummaryWizardData';
import DocumentSpecReviewWizard from '../Specs Review Complete/DocumentSpecReviewWizard';
import { initialValuesSpecReview } from '../Specs Review Complete/InitialValuesSpecReviewWizard';
import NotesSpecReviewWizard from '../Specs Review Complete/NotesSpecReviewWizard';
import SummarySpecReviewWizard from '../Specs Review Complete/SummarySpecReviewWizard';
import SurveySpecReviewWizard from '../Specs Review Complete/SurveySpecReviewWizard';
import './ActionWizard.css';
import { initialValuesContactWizard } from '../SaleWizardData/ContactWizardInitialValues';

import DocumentAcceptSaleWizard from '../Accept Sale Wizard/DocumentAcceptSaleWizard';
import { initialValuesJobScope } from '../Accept Sale Wizard/InitialValuesJobScope';
import { initialValuesPermit, initialValuesSpecException } from '../Accept Sale Wizard/InitialValuesPermitWizard';
import { initialValuesSalesAcceptedWizard } from '../Accept Sale Wizard/InitialValuesSaleAcceptedWizard';
import JobScopeWizard from '../Accept Sale Wizard/JobScopeAcceptSaleWizard';
import NotesAcceptSalesWizard from '../Accept Sale Wizard/NotesAcceptSalesWizard';
import PermitAcceptSaleWizard from '../Accept Sale Wizard/PermitAcceptSaleWizard';
import SalesInfoAcceptSaleWizard from '../Accept Sale Wizard/SalesInfoAcceptSaleWizard';
import SpecificationExceptionSaleWizard from '../Accept Sale Wizard/SpecExceptionAcceptSaleWizard';
import SummaryAcceptSaleWizard from '../Accept Sale Wizard/SummaryAcceptSaleWizard';
import DocumentContractual from '../Contractual Review/DocumentContractual';
import NotesContractualWizard from '../Contractual Review/NotesContractualWizard';
import SummaryContractualWizard from '../Contractual Review/SummaryContractualWizard';
import Survey from '../EcdReviewedWizard/Survey';
import Summary from '../EcdReviewedWizard/Summary';
import DRCSummary from '../DRCWizard/DRCSummary';
import DRCSignOffSurvey from '../DRCSignOff/DRCSignOffSurvey';
import DRCSignOffSummary from '../DRCSignOff/DRCSignOffSummary';
import { DRCSignOffInitialValues, ECDWizardInitialValues } from './ActionWizardInitialValues';
import PCCSummary from '../PCCWizard.tsx/PCCSummary';
import PCCSignOffSummary from '../PCCSignOffReviewed/PCCSignOffSummary';
import PCCSignOffSurvey from '../PCCSignOffReviewed/PCCSignOffSurvey';
import SendToPurchasingSummary from '../SendToPurchasing/SendToPurchasingSummary';
import ReadyForConstructionSummary from '../ReadyForConstruction/ReadyForConstructionSummary';
import MarkInConstructionSummary from '../MarkInConstruction/MarkInConstructionSummary';
import MarkSubstantialCompleteSummary from '../MarkSubstantialComplete/MarkSubstantialCompleteSummary';
import MarkCompleteSummary from '../MarkComplete/MarkCompleteSummary';
import DetailsCancelWizar from '../Cancel Wizard/DetailsCancelWizar';
import DetailsMarkAsDead from '../Mark as Dead Wizard/DetailsMarkAsDead';
import DetailsPromoteLead from '../PromoteLeadToSw/DetailsPromoteLead';
import AddressesPromoteLead from '../PromoteLeadToSw/AddressesPromoteLead';
import SummaryPromoteLeadToSw from '../PromoteLeadToSw/SummaryPromoteLeadToSw';
import * as Yup from "yup"


const ActionWizard = ({ refetchProject,setRefetchApiAfterWizard, getallActiveUsers, refetchClientView, setActions, refetchWizardActions, actions, wizardTabs, storeProjectId, projectRecordNumber, refetchAssignments, togglestepperAssignment, projectId, BusinessUnitValue, closestepper, isEditing, projectLookups }: any) => {

  const [showRibbon, setShowRibbon] = useState(true)
  const [showHistory, setShowHistory] = useState(true)
  const [showRibbonJobScope, setShowRibbonJobScope] = useState(true)
  const [comment, setComment] = useState('')
  const [contigencyResume, setContigencyResume] = useState({ label: '', value: '' })
  const [pohReason, setPohReason] = useState({ label: '', value: '' })
  const [activeStep, setActiveStep] = useState(0);
  const [opportunityData, setOpportunityData] = useState<Record<string, any> | null>({});
  const [opportunityInitialValues, setOpportunityInitialValues] = useState<Record<string, any> | null>(null);
  const [jobScopeData, setJobScopeData] = useState<Record<string, any> | null>({});
  const [jobScopeInitialValues, setJobScopeInitialValues] = useState<Record<string, any> | null>(null);
  const [jobScopeDetailsData, setJobScopeDetailsData] = useState({});
  const [remainingAmount, setRemainingAmount] = useState("0");
  const [opportunityDetailsData, setOpportunityDetailsData] = useState({});
  const [showSpecificationExceptionData, setShowSpecificationExceptionData] = useState<Record<string, any> | null>({})
  const [showSpecificationExceptionUpdate, setShowSpecificationExceptionUpdate] = useState({})
  const [saleInfoData, setSaleInfoData] = useState<Record<string, any> | null>({})
  const [acceptedSaleInfoData, setAcceptedSaleInfoData] = useState<Record<string, any> | null>({})
  const [toogle, setToogle] = useState(true)
  const [adressConfirm, setAdressConfirm] = useState(false)
  const [showContactData, setShowContactData] = useState<Record<string, any> | null>({})
  const [showContactUpdatedData, setShowContactUpdatedData] = useState({})
  const [cancelWizardState, setCancelWizardState] = useState({ label: '', value: '' })
  const [deadWizardState, setDeadWizardState] = useState({ label: '', value: '' })
  const [saleInfoTrigger, setSaleInfoTrigger] = useState(false)
  const [documentCheck, setDocumentCheck] = useState(false)
  const statusId = actions?.value
  const assigned = actions?.value ? true : false;
  //steps sales....
  const steps = wizardTabs?.result
    .filter((item: any) => item.id > 1)
    .map((item: any) => item.value);
  //steps Put on hold.....
  const stepsPOH = wizardTabs?.result
    .filter((item: any) => item.id > 1)
    .map((item: any) => item.value);
  //steps specreview....
  const stepsSpecReview = wizardTabs?.result
    .filter((item: any) => item.id > 1)
    .map((item: any) => item.value);
  //steps contractual.....
  const stepsContractual = wizardTabs?.result
    .filter((item: any) => item.id > 1)
    .map((item: any) => item.value);
  //steps stepsResume
  const stepsResume = wizardTabs?.result
    .filter((item: any) => item.id > 1)
    .map((item: any) => item.value);
  const stepsAcceptSale = wizardTabs?.result
    .filter((item: any) => item.id > 1)
    .map((item: any) => item.value);
  const stepsECDReviewed =
    // ['Note', 'Documents', 'Survey', 'Summary']
    wizardTabs?.result
      .filter((item: any) => item.id > 1)
      .map((item: any) => item.value);
  const stepsDRC = wizardTabs?.result
    .filter((item: any) => item.id > 1)
    .map((item: any) => item.value);
  const stepsDRCSignOff = wizardTabs?.result
    .filter((item: any) => item.id > 1)
    .map((item: any) => item.value);
  const stepsPCC = wizardTabs?.result
    .filter((item: any) => item.id > 1)
    .map((item: any) => item.value);
  const stepsPCCSignOff = wizardTabs?.result
    .filter((item: any) => item.id > 1)
    .map((item: any) => item.value);
  const stepsSendToPurchasing = wizardTabs?.result
    .filter((item: any) => item.id > 1)
    .map((item: any) => item.value);
  const stepsReadyForConstruction = wizardTabs?.result
    .filter((item: any) => item.id > 1)
    .map((item: any) => item.value);
  const stepsMarkInConstruction = wizardTabs?.result
    .filter((item: any) => item.id > 1)
    .map((item: any) => item.value);
  const stepsMarkSubstantialComplete = wizardTabs?.result
    .filter((item: any) => item.id > 1)
    .map((item: any) => item.value);
  const stepsMarkComplete = wizardTabs?.result
    .filter((item: any) => item.id > 1)
    .map((item: any) => item.value);
  const stepsCancel = wizardTabs?.result
    .filter((item: any) => item.id > 1)
    .map((item: any) => item.value);
  const stepsMarkAsDead = wizardTabs?.result
    .filter((item: any) => item.id > 1)
    .map((item: any) => item.value);
  const stepsPromoteLeadToSw = wizardTabs?.result
    .filter((item: any) => item.id > 1)
    .map((item: any) => item.value);
  const StepsRescind = wizardTabs?.result
    .filter((item: any) => item.id > 1)
    .map((item: any) => item.value);

  //Project Data byStore
  const projectData = useSelector((state: any) => state.common.projectData);
  //Upsert Sale Info Api
  const [UpsertSaleInfo, { data: UpsertData, isError, error }] = useUpsertSaleInfoDetailsMutation()
  //CreateProjectApiForStatusUpdate
  const [UpdateProjectStatus, { data: ProjectStatus, isSuccess, isLoading: isLoadingStatus }] = useUpdateProjectActionsMutation()
  //Compare Opportunities
  const [compareOpportunity, { data: compareOpportunityDetailData, isLoading }] = useCompareOpportunitiesMutation()
  //Update Opportunities
  const [updateOpportunityDetails] = useUpsertOpportunityDetailsMutation()
  // upsert Review Api
  const [UpsertSpecReview, { data: UpsertSpecReviewData }] = useUpsertSpecReviewMutation()
  // upsert Sale Accepted Api
  const [UpsertAcceptedSale, { data: UpsertAcceptedSaleInfo, isSuccess: isSuccessAcceptedSale }] = useUpsertAcceptedSaleInfoDetailsMutation()
  // upsert Permit Api
  const [UpsertPermitSale, { data: UpsertPermitInfo }] = useUpsertprojectPermitDetailsMutation()
  //Upsert job scope Api
  const [UpsertJobScope, { data: upsertJobScopeData }] = useUpsertJobScopeMutation();
  //GetContactDetails in Project Api
  const [TriggerContactbyId, { data: getContactbyId }] = useLazyGetContactDetailsInProjectQuery()
  //Update Contact Api
  const [UpdateContact, { data: updatedata, isError: updateIsError, error: updateError, isSuccess: updateIsSuccess, isLoading: updateIsLoading }] =
    useUpdateContactDetailsInProjectMutation();
  //Contacts Lookup
  const { data: getContactLookup, refetch } = useGetContactLookupQuery('');
  //upsert Ecd api
  const [UpsertECDReview] = useUpsertECDReviewSurveyMutation()
  //upsert DRc Api
  const [UpsertDrcSignReview] = useUpsertDrcSignReviewSurveyMutation()
  // upsert pcc api 
  const [UpsertPccReviewSurvey] = useUpsertPccReviewSurveyMutation()
  //Upsert Promote TO Sw
  const [UpsertPromoteToSw] = useUpsertPromoteToSwMutation()
  //Spec Exception tab in accepted sale wizard
  const [UpsertException, { data }] = useCreateUpdateSpecificationExceptionMutation();
  //Get All Project Notes 
  const [triggerNotesApi, { data: projectNotes }] = useLazyGetAllProjectNotesQuery();
  //Sale Info Api
  const [triggerSaleInfo, { data: saleInfo }] = useLazyGetSaleInfoByIdQuery()
  //send Email After action
  const [sendEmailAfterAction] = useSendEmailAfterActionMutation()



  const initailValuesProjectStatus = {
    projectId: storeProjectId,
    actionId: statusId,
    comments: comment,
    createdBy: 0,
    modifiedBy: 0
  }

  const validationSchemaContact = Yup.object({
    primaryContactVMs: Yup.object({
      homeEmail: Yup.string()
        .email("Please enter a valid email address")
        .required("Email is required"),
    }),
  });

  const formikProjectStatus = useFormik({
    // validationSchema: LeadsSchema,
    initialValues: initailValuesProjectStatus,

    onSubmit: (values) => {
      UpdateProjectStatus({ ...values, actionId: statusId, isAssigned: assigned, comments: comment, });
    },

  });

  //opportunities formik 

  const [isFirstSubmit, setIsFirstSubmit] = useState(true);

  const formikOpportunities = useFormik({
    initialValues: initialValuesOpportunities,
    // validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      if (isFirstSubmit) {
        compareOpportunity(values);
        setIsFirstSubmit(false);
      } else {
        updateOpportunityDetails(values);
      }
    }
  });

  //Formik Spec Exception in Accepted Sale Wizard

  const formikSpecException = useFormik({
    initialValues: initialValuesSpecException,
    onSubmit: (values) => {
      UpsertException({ ...values })
    },
  });


  //Formik for Spec Review start

  const formikSpecReview = useFormik({
    // validationSchema: LeadsSchema,
    initialValues: initialValuesSpecReview,
    onSubmit: (values) => {
      UpsertSpecReview({ ...values });
    },

  })

  //Formik for Spec Review end

  //Formik Promote TO Sw

  const formikPromoteToSw = useFormik({
    // validationSchema: LeadsSchema,
    initialValues: initialValuesPromoteToSw,
    onSubmit: (values) => {
      UpsertPromoteToSw({ ...values });
    },

  })
  // Formik Promote To Sw End

  //Formik Sale Accepted start

  const formikAcceptedSale = useFormik({
    // validationSchema: LeadsSchema,
    initialValues: initialValuesSalesAcceptedWizard,
    onSubmit: (values) => {
      UpsertAcceptedSale({ ...values, projectId: storeProjectId });
    },

  })

  //Formik Sale Accepted end

  //Formik Permit Sale Accepted start

  const formikPermitSale = useFormik({
    // validationSchema: LeadsSchema,
    initialValues: initialValuesPermit,
    onSubmit: (values) => {
      UpsertPermitSale({ ...values });
    },

  })

  //Formik Permit Sale Accepted end

  //Formik job Scope start

  const formikJobScope = useFormik({
    initialValues: initialValuesJobScope,
    onSubmit: (values) => {
      UpsertJobScope({ ...values })
    },

  });

  //Formik job Scope end

  //Formik Sales

  const formikSales = useFormik({
    // validationSchema:validationSchemaContact,
    initialValues: initialValuesSale,
    // validateOnChange: true,
    // validateOnBlur: true, 
    onSubmit: (values) => {
      UpsertSaleInfo({ ...values, projectId: storeProjectId });
    },

  });

  const { resetForm } = formikSales;
  const { resetForm: resetOpportunity } = formikOpportunities
  //Formik
  const formikContact = useFormik({
    initialValues: initialValuesContactWizard,
    // validationSchema: contactSchema,
    onSubmit: (values) => {
      UpdateContact({ ...values })
    },
  });

  // EDC Start
  // const [GetEcdReviewSurveyDetailsTrigger, { data: getEcdReviewSurveyData }] = useLazyGetEcdReviewSurveyDetailsQuery({  });

  //Formik ECD Reviewed
  const formikECDReviewed = useFormik({
    initialValues: ECDWizardInitialValues,
    // validationSchema: contactSchema,
    onSubmit: (values) => {
      UpsertECDReview({ ...values })
    },
  });

  // EDC END

  // DRC Sign OFF START

  const formikDrcSignOff = useFormik({
    initialValues: DRCSignOffInitialValues,
    // validationSchema: contactSchema,
    onSubmit: (values) => {
      UpsertDrcSignReview({ ...values })
    },
  });
  // DRC Sign OFF  END

  // PCC OFF START


  const formikPccReview = useFormik({
    initialValues: DRCSignOffInitialValues,
    // validationSchema: contactSchema,
    onSubmit: (values) => {
      UpsertPccReviewSurvey({ ...values })
    },
  });

  // PCC OFF END


  const [totalAmount, setTotalAmount] = useState(0);

  const getSalesContent = (stepIndex: number) => {

    switch (stepIndex) {
      case 0:
        return <ContactWizardData projectData={projectData} getContactbyId={getContactbyId} getContactLookup={getContactLookup} formik={formikContact} setToogle={setToogle} toogle={toogle} setShowContactData={setShowContactData} showContactUpdatedData={showContactUpdatedData} />;
      case 1:
        return <AddressesWizardData formik={formikContact} adressConfirm={adressConfirm} setAdressConfirm={setAdressConfirm} />;
      case 2:
        return <OpportunityDetailsWizard storeProjectId={storeProjectId} showRibbon={showRibbon} setOpportunityData={setOpportunityData} setOpportunityInitialValues={setOpportunityInitialValues} opportunityDetailsData={opportunityDetailsData} formikOpportunities={formikOpportunities} />
      case 3:
        return <SalesInfoWizardData actions={actions} activeStep={activeStep} saleInfoTrigger={saleInfoTrigger} setTotalAmount={setTotalAmount} storeProjectId={storeProjectId} formik={formikSales} remainingAmount={remainingAmount} setRemainingAmount={setRemainingAmount} getallActiveUsers={getallActiveUsers} setSaleInfoData={setSaleInfoData} projectLookups={projectLookups} />
      case 4:
        return <NotesWizardData setComment={setComment} comment={comment} />;
      case 5:
        return <DocumentWizardData setDocumentCheck={setDocumentCheck} documentCheck={documentCheck} />;
      case 6:
        return <SummaryWizardData contactInfoData={formikContact?.values} saleInfoData={formikSales?.values} opportunityData={opportunityData} opportunityInitialValues={opportunityInitialValues} saleInfoApi={saleInfoData} totalAmount={totalAmount} compareOpportunityDetailData={compareOpportunityDetailData} />;
      default:
        return 'Unknown stepIndex';
    }
  };

  const getPOHContent = (stepIndex: number) => {

    switch (stepIndex) {
      case 0:
        return <DetailsPOHWizardData projectLookups={projectLookups} setComment={setComment} comment={comment} pohReason={pohReason} setPohReason={setPohReason} />
      case 1:
        return <DocumentPOHWizardData setDocumentCheck={setDocumentCheck} documentCheck={documentCheck} storeProjectId={storeProjectId} />
      case 2:
        return <SummaryPOHWizardData comment={comment} pohReason={pohReason} />
      default:
        return 'Unknown stepIndex';
    }
  };
  const getResumeContent = (stepIndex: number) => {

    switch (stepIndex) {
      case 0:
        return <DetailsResumeWizardData setComment={setComment} comment={comment} projectLookups={projectLookups} contigencyResume={contigencyResume} setContigencyResume={setContigencyResume} />
      case 1:
        return <DocumentResumeWizardData setDocumentCheck={setDocumentCheck} documentCheck={documentCheck} storeProjectId={storeProjectId} />
      case 2:
        return <SummaryResumeWizardData comment={comment} contigencyResume={contigencyResume} />
      default:
        return 'Unknown stepIndex';
    }
  };

  const getSpecReview = (stepIndex: number) => {

    switch (stepIndex) {
      case 0:
        return <NotesSpecReviewWizard setComment={setComment} comment={comment} />
      // case 1:
      //   return <SurveySpecReviewWizard projectLookups={projectLookups} formikSpecReview={formikSpecReview} />
      case 1:
        return <DocumentSpecReviewWizard setDocumentCheck={setDocumentCheck} documentCheck={documentCheck} storeProjectId={storeProjectId} />

      case 2:
        return <SummarySpecReviewWizard comment={comment} formikSpecReview={formikSpecReview} />
      default:
        return 'Unknown stepIndex';
    }
  };
  const getContractualReview = (stepIndex: number) => {

    switch (stepIndex) {
      case 0:
        return <NotesContractualWizard setComment={setComment} comment={comment} />
      case 1:
        return <DocumentContractual setDocumentCheck={setDocumentCheck} documentCheck={documentCheck} storeProjectId={storeProjectId} />
      case 2:
        return <SummaryContractualWizard comment={comment} />
      default:
        return 'Unknown stepIndex';
    }
  };
  const getAcceptedSale = (stepIndex: number) => {

    switch (stepIndex) {
      case 0:
        return <JobScopeWizard showRibbonJobScope={showRibbonJobScope} showHistory={showHistory} storeProjectId={storeProjectId} setJobScopeData={setJobScopeData} setJobScopeInitialValues={setJobScopeInitialValues} jobScopeDetailsData={jobScopeDetailsData} formik={formikJobScope} />
      case 1:
        return <SalesInfoAcceptSaleWizard setAcceptedSaleInfoData={setAcceptedSaleInfoData} formikAcceptedSale={formikAcceptedSale} getallActiveUsers={getallActiveUsers} storeProjectId={storeProjectId} />
      case 2:
        return <SpecificationExceptionSaleWizard showRibbon={showRibbon} formik={formikSpecException} storeProjectId={storeProjectId} projectLookups={projectLookups} setShowSpecificationExceptionData={setShowSpecificationExceptionData} showSpecificationExceptionUpdate={showSpecificationExceptionUpdate} />
      case 3:
        return <PermitAcceptSaleWizard formikPermitSale={formikPermitSale} storeProjectId={storeProjectId} />
      case 4:
        return <DocumentAcceptSaleWizard setDocumentCheck={setDocumentCheck} documentCheck={documentCheck} storeProjectId={storeProjectId} />
      case 5:
        return <NotesAcceptSalesWizard comment={comment} setComment={setComment} />
      case 6:
        return <SummaryAcceptSaleWizard formikAcceptedSale={formikAcceptedSale.values} jobScopeDetailsData={jobScopeDetailsData} saleInfoByApi={acceptedSaleInfoData} formikPermitSale={formikPermitSale} comment={comment} />
      default:
        return 'Unknown stepIndex';
    }
  };
  const ecdReviewed = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return <NotesAcceptSalesWizard comment={comment} setComment={setComment} />
      case 1:
        return <DocumentContractual documentCheck={documentCheck} setDocumentCheck={setDocumentCheck} storeProjectId={storeProjectId} />
      // case 2:
      //   return <Survey storeProjectId={storeProjectId} formikECDReviewed={formikECDReviewed} projectLookups={projectLookups} />
      case 2:
        return <Summary comment={comment} />
      default:
        return 'Unknown stepIndex';
    }
  };
  const drcWizardReviewed = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return <NotesAcceptSalesWizard comment={comment} setComment={setComment} />
      case 1:
        return <DocumentContractual documentCheck={documentCheck} setDocumentCheck={setDocumentCheck} storeProjectId={storeProjectId} />
      case 2:
        return <DRCSummary comment={comment} />
      default:
        return 'Unknown stepIndex';
    }
  };
  const drcSignOff = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return <NotesAcceptSalesWizard comment={comment} setComment={setComment} />
      case 1:
        return <DocumentContractual documentCheck={documentCheck} setDocumentCheck={setDocumentCheck} storeProjectId={storeProjectId} />
      // case 2:
      //   return <DRCSignOffSurvey storeProjectId={storeProjectId} formikDrcSignOff={formikDrcSignOff} projectLookups={projectLookups} />
      case 2:
        return <DRCSignOffSummary comment={comment} />
      default:
        return 'Unknown stepIndex';
    }
  };
  const pccWizardReviewed = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return <NotesAcceptSalesWizard comment={comment} setComment={setComment} />
      case 1:
        return <DocumentContractual documentCheck={documentCheck} setDocumentCheck={setDocumentCheck} storeProjectId={storeProjectId} />
      case 2:
        return <PCCSummary comment={comment} />
      default:
        return 'Unknown stepIndex';
    }
  };
  const pccSignOffWizardReviewed = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return <NotesAcceptSalesWizard comment={comment} setComment={setComment} />
      case 1:
        return <DocumentContractual documentCheck={documentCheck} setDocumentCheck={setDocumentCheck} storeProjectId={storeProjectId} />
      // case 2:
      //   return <PCCSignOffSurvey storeProjectId={storeProjectId} formikPccReview={formikPccReview} projectLookups={projectLookups} />
      case 2:
        return <PCCSignOffSummary comment={comment} />
      default:
        return 'Unknown stepIndex';
    }
  };
  const sendToPurchasingWizardReviewed = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return <NotesAcceptSalesWizard comment={comment} setComment={setComment} />
      case 1:
        return <DocumentContractual documentCheck={documentCheck} setDocumentCheck={setDocumentCheck} storeProjectId={storeProjectId} />
      case 2:
        return <SendToPurchasingSummary comment={comment} />
      default:
        return 'Unknown stepIndex';
    }
  };
  const readyForConstructionWizardReviewed = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return <NotesAcceptSalesWizard comment={comment} setComment={setComment} />
      case 1:
        return <DocumentContractual documentCheck={documentCheck} setDocumentCheck={setDocumentCheck} storeProjectId={storeProjectId} />
      case 2:
        return <ReadyForConstructionSummary comment={comment} />
      default:
        return 'Unknown stepIndex';
    }
  };
  const markInConstructionWizardReviewed = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return <NotesAcceptSalesWizard comment={comment} setComment={setComment} />
      case 1:
        return <DocumentContractual documentCheck={documentCheck} setDocumentCheck={setDocumentCheck} storeProjectId={storeProjectId} />
      case 2:
        return <MarkInConstructionSummary comment={comment} />
      default:
        return 'Unknown stepIndex';
    }
  };
  const markSubstantialCompleteWizardReviewed = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return <NotesAcceptSalesWizard comment={comment} setComment={setComment} />
      case 1:
        return <DocumentContractual documentCheck={documentCheck} setDocumentCheck={setDocumentCheck} storeProjectId={storeProjectId} />
      case 2:
        return <MarkSubstantialCompleteSummary comment={comment} />
      default:
        return 'Unknown stepIndex';
    }
  };
  const markCompleteWizardReviewed = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return <NotesAcceptSalesWizard comment={comment} setComment={setComment} />
      case 1:
        return <DocumentContractual documentCheck={documentCheck} setDocumentCheck={setDocumentCheck} storeProjectId={storeProjectId} />
      case 2:
        return <MarkCompleteSummary comment={comment} />
      default:
        return 'Unknown stepIndex';
    }
  };
  const cancelWizardData = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return <DetailsCancelWizar comment={comment} setComment={setComment} projectLookups={projectLookups} cancelWizardState={cancelWizardState} setCancelWizardState={setCancelWizardState} />
      case 1:
        return <DocumentContractual documentCheck={documentCheck} setDocumentCheck={setDocumentCheck} storeProjectId={storeProjectId} />
      case 2:
        return <DRCSummary comment={comment} cancelWizardState={cancelWizardState} />
      default:
        return 'Unknown stepIndex';
    }
  };
  const markAsDeadWizardData = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return <DetailsMarkAsDead comment={comment} setComment={setComment} projectLookups={projectLookups} deadWizardState={deadWizardState} setDeadWizardState={setDeadWizardState} />
      case 1:
        return <DocumentContractual documentCheck={documentCheck} setDocumentCheck={setDocumentCheck} storeProjectId={storeProjectId} />
      case 2:
        return <DRCSummary comment={comment} deadWizardState={deadWizardState} />
      default:
        return 'Unknown stepIndex';
    }
  };
  const rescindData = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return <NotesAcceptSalesWizard comment={comment} setComment={setComment} />
      case 1:
        return <DocumentContractual documentCheck={documentCheck} setDocumentCheck={setDocumentCheck} storeProjectId={storeProjectId} />
      case 2:
        return <DRCSummary comment={comment} />
      default:
        return 'Unknown stepIndex';
    }
  };
  const promoteLeadToSW = (stepIndex: number) => {
    switch (stepIndex) {
      case 0:
        return <DetailsPromoteLead formik={formikPromoteToSw} getallActiveUsers={getallActiveUsers} projectRecordNumber={projectRecordNumber} />
      case 1:
        return <AddressesPromoteLead formik={formikPromoteToSw} />
      case 2:
        return <DocumentContractual documentCheck={documentCheck} setDocumentCheck={setDocumentCheck} storeProjectId={storeProjectId} />
      case 3:
        return <NotesAcceptSalesWizard comment={comment} setComment={setComment} formikPromoteToSw={formikPromoteToSw} />
      case 4:
        return <SummaryPromoteLeadToSw comment={comment} formik={formikPromoteToSw} projectRecordNumber={projectRecordNumber} />
      default:
        return 'Unknown stepIndex';
    }
  };

  const validateCurrentStep = () => {
    if (actions.value === 4 && activeStep === 3) {
      const { saleDate, salePrice, lst_SaleRepresentative } = formikSales.values;
      return (
        saleDate &&
        lst_SaleRepresentative?.id &&
        salePrice
      );
    }
    // if (actions.value === 36 && activeStep === 2) {
    //   const { lst_ExceptionType, lst_ExceptionCategory, notes } = formikSpecException.values;
    //   return (
    //     lst_ExceptionType?.id &&
    //     lst_ExceptionCategory?.id
    //   );
    // }
    if (actions.value === 36 && activeStep === 1) {
      const { pdmJobCost, reviewedCost } = formikAcceptedSale.values;
      return (
        pdmJobCost &&
        reviewedCost
      );
    }
    if (actions.value === 4 && activeStep === 0) {
      const { primaryContactVMs, secondaryContactVMs } = formikContact.values;
      if (!toogle) {
        return (
          primaryContactVMs?.contactType?.id &&
          primaryContactVMs?.salutation?.id &&
          primaryContactVMs?.firstName &&
          primaryContactVMs?.lastName
        ) ? true : false;
      } else {
        return (
          secondaryContactVMs?.contactType?.id &&
          secondaryContactVMs?.salutation?.id &&
          secondaryContactVMs?.firstName &&
          secondaryContactVMs?.lastName
        ) ? true : false;
      }
    }
    if (actions.value === 4 && activeStep === 1) {
      const { primaryContactVMs } = formikContact.values;
      return (
        primaryContactVMs?.propertyAddress?.addressLine1 &&
        primaryContactVMs?.propertyAddress?.zipCode &&
        primaryContactVMs?.propertyAddress?.stateName &&
        primaryContactVMs?.propertyAddress?.cityName &&
        primaryContactVMs?.mailingAddress?.addressLine1 &&
        primaryContactVMs?.mailingAddress?.zipCode &&
        primaryContactVMs?.mailingAddress?.stateName &&
        primaryContactVMs?.mailingAddress?.cityName
      )
    }
    if (actions.value === 4 && activeStep === 2) {
      const { opportunityDetailsDescription } = formikOpportunities.values;
      return (
        opportunityDetailsDescription?.description &&
        opportunityDetailsDescription?.jobType
      )
    }
    if (actions.value === 3 && activeStep === 0) {
      return (
        pohReason?.value
      )
    }
    if (actions.value === 14 && activeStep === 0) {
      return (
        contigencyResume?.value
      )
    }
    // if (actions.value === 13 && activeStep === 0) {
    //   return (
    //     comment
    //   )
    // }
    // if (actions.value === 12 && activeStep === 0) {
    //   return (
    //     comment
    //   )
    // }
    // if (actions.value === 15 && activeStep === 0) {
    //   return (
    //     comment
    //   )
    // }
    // if (actions.value === 37 && activeStep === 0) {
    //   return (
    //     comment
    //   )
    // }
    // if (actions.value === 19 && activeStep === 0) {
    //   return (
    //     comment
    //   )
    // }
    // if (actions.value === 21 && activeStep === 0) {
    //   return (
    //     comment
    //   )
    // }
    // if (actions.value === 23 && activeStep === 0) {
    //   return (
    //     comment
    //   )
    // }
    // if (actions.value === 25 && activeStep === 0) {
    //   return (
    //     comment
    //   )
    // }
    // if (actions.value === 27 && activeStep === 0) {
    //   return (
    //     comment
    //   )
    // }
    // if (actions.value === 30 && activeStep === 0) {
    //   return (
    //     comment
    //   )
    // }
    // if (actions.value === 31 && activeStep === 0) {
    //   return (
    //     comment
    //   )
    // }
    // if (actions.value === 33 && activeStep === 0) {
    //   return (
    //     comment
    //   )
    // }
    // if (actions.value === 2 && activeStep === 0) {
    //   return (
    //     comment
    //   )
    // }
    // if (actions.value === 6 && activeStep === 0) {
    //   return (
    //     comment
    //   )
    // }
    // if (actions.value === 10 && activeStep === 0) {
    //   return (
    //     comment
    //   )
    // }
    if (actions.value === 4 && activeStep === 5) {
      return (
        documentCheck === true
      )
    }
    if (actions.value === 5 && activeStep === 2) {
      return (
        documentCheck === true
      )
    }
    if (activeStep === 1 && (actions.value === 3 || actions.value === 10 || actions.value === 6 || actions.value === 2 || actions.value === 33 || actions.value === 31 || actions.value === 30 ||
      actions.value === 27 || actions.value === 25 || actions.value === 23 ||
      actions.value === 21 || actions.value === 19 || actions.value === 37 ||
      actions.value === 15 || actions.value === 12 || actions.value === 13 ||
      actions.value === 14)) {
      return (
        documentCheck === true
      )
    }
    return true;
  };

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const handleNext = () => {

    if (actions.value === 4) {
      setOpportunityDetailsData(opportunityData?.values);
      if (activeStep < steps.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setShowContactUpdatedData(showContactData?.values)
      } else {
        formikSales.handleSubmit()
        formikContact.handleSubmit()
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: '' })
        }, 3000);
        formikOpportunities.handleSubmit()
      }
      if (activeStep === 4) {
        formikOpportunities.handleSubmit()
      }
      if (activeStep === 3) {
        setSaleInfoTrigger(true)
      }
    }
    else if (actions.value === 3) {
      if (activeStep < stepsPOH.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      else {
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: pohReason?.label })
        }, 3000);
      }
    }
    else if (actions.value === 14) {
      if (activeStep < stepsResume.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      else {
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: contigencyResume?.label })
        }, 3000);
        refetchProject()
      }
    }
    else if (actions.value === 13) {
      if (activeStep < stepsSpecReview.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      else {
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: '' })
        }, 3000);
        formikSpecReview.handleSubmit()
      }
    }
    else if (actions.value === 12) {
      if (activeStep < stepsContractual.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      else {
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: '' })
        }, 3000);
      }
    }
    else if (actions.value === 36) {
      setJobScopeDetailsData(jobScopeData?.values)
      setShowSpecificationExceptionUpdate(showSpecificationExceptionData?.values)
      if (activeStep < stepsAcceptSale.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      else {
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: '' })
        }, 3000);
        formikAcceptedSale.handleSubmit()
        formikPermitSale.handleSubmit()
        formikJobScope.handleSubmit()
      }
      if (activeStep === 4) {
        formikJobScope.handleSubmit()
      }
    }
    else if (actions.value === 15) {
      if (activeStep < stepsECDReviewed.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      else {
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: '' })
        }, 3000);
        formikECDReviewed.handleSubmit();
      }
    }
    else if (actions.value === 37) {
      if (activeStep < stepsDRC.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      else {
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: '' })
        }, 3000);
      }
    }
    else if (actions.value === 19) {
      if (activeStep < stepsDRCSignOff.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      else {
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: '' })
        }, 3000);
        formikDrcSignOff.handleSubmit();
      }
    }
    else if (actions.value === 21) {
      if (activeStep < stepsPCC.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      else {
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: '' })
        }, 3000);
      }
    }
    else if (actions.value === 23) {
      if (activeStep < stepsPCCSignOff.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      else {
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: '' })
        }, 3000);
        formikPccReview.handleSubmit();
      }
    }
    else if (actions.value === 25) {
      if (activeStep < stepsSendToPurchasing.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      else {
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: '' })
        }, 3000);
      }
    }
    else if (actions.value === 27) {
      if (activeStep < stepsReadyForConstruction.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      else {
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: '' })
        }, 3000);
      }
    }
    else if (actions.value === 30) {
      if (activeStep < stepsMarkInConstruction.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      else {
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: '' })
        }, 3000);
      }
    }
    else if (actions.value === 31) {
      if (activeStep < stepsMarkSubstantialComplete.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      else {
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: '' })
        }, 3000);
      }
    }
    else if (actions.value === 33) {
      if (activeStep < stepsMarkComplete.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      else {
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: '' })
        }, 3000);
      }
    }
    else if (actions.value === 2) {
      if (activeStep < stepsCancel.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      else {
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: cancelWizardState.label })
        }, 3000);
      }
    }
    else if (actions.value === 6) {
      if (activeStep < stepsMarkAsDead.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      else {
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: deadWizardState.label })
        }, 3000);
      }
    }
    else if (actions.value === 5) {
      if (activeStep < stepsPromoteLeadToSw.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      else {
        formikPromoteToSw.handleSubmit();
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: '' })
        }, 3000);
      }
    }
    else if (actions.value === 10) {
      if (activeStep < StepsRescind.length - 1) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      else {
        formikProjectStatus.handleSubmit()
        setTimeout(() => {
          sendEmailAfterAction({ ProjectId: storeProjectId, ActionId: actions.value, Reason: '' })
        }, 3000);
      }
    }

  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    if (activeStep === 3) {
      setSaleInfoTrigger(true)
    }
  };

  useEffect(() => {
    if (isSuccess) {
      toast.success(ProjectStatus?.message);
      closestepper();
      resetForm()
      refetchProject()
      refetchWizardActions()
      setActions('')
      setContigencyResume({ label: '', value: '' })
      setPohReason({ label: '', value: '' })
      triggerNotesApi({ ProjectId: storeProjectId })
      triggerSaleInfo({ ProjectId: storeProjectId })
      refetchClientView()
      setDocumentCheck(false)
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError && error) {
      let errorMessage: string = 'Something went wrong';

      if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
        errorMessage = (error.data as { message: string }).message;
      }
      toast.error(errorMessage);
      resetForm()
    }
  },
    [isError, error]);

  useEffect(() => {
    if (closestepper) {
      setActiveStep(0)
      setComment('')
      setAdressConfirm(false)
      setSaleInfoTrigger(false)
      resetForm()
      setDocumentCheck(false)
    }
  }, [closestepper])

  useEffect(() => {
    if (togglestepperAssignment && actions.value === 4 && activeStep === 0) {
      TriggerContactbyId({ projectId: storeProjectId })
    }
  }, [togglestepperAssignment, actions.value, activeStep])


  // useEffect(() => {
  //   getEcdReviewSurveyRefetch();
  //   getDrcSignReviewSurveyRefetch();
  //   getPccReviewSurveyDetailsRefetch();
  // }, []);


  useEffect(() => {
    if (togglestepperAssignment === true) {
      setShowRibbon(true)
      setShowRibbonJobScope(true)
      setShowHistory(true)
    }
  }, [togglestepperAssignment])


  useEffect(() => {
    if (activeStep === 4) {
      setIsFirstSubmit(true);
    }
  }, [activeStep]);

  useEffect(() => {
    if (isSuccessAcceptedSale) {
      setRefetchApiAfterWizard(true)
    }
  }, [isSuccessAcceptedSale])


  // const getStepComponent = (stepIndex: number) => {
  //   switch (steps[stepIndex]) {
  //     case 'Contact Info':
  //       return (
  //         <ContactWizardData
  //           projectData={projectData}
  //           getContactbyId={getContactbyId}
  //           getContactLookup={getContactLookup}
  //           formik={formikContact}
  //         />
  //       );
  //     case 'Addresses':
  //       return <DocumentWizardData />;
  //     case 'Opportunity Details':
  //       return (
  //         <OpportunityDetails
  //           storeProjectId={storeProjectId}
  //           showRibbon={showRibbon}
  //         />
  //       );
  //     case 'Sales Info':
  //       return (
  //         <SalesInfoWizardData
  //           storeProjectId={storeProjectId}
  //           formik={formik}
  //         />
  //       );
  //     case 'Summary':
  //       return <SummaryWizardData />;
  //     default:
  //       return 'Unknown stepIndex';
  //   }
  // };



  return (
    <div className={togglestepperAssignment ? "toggle-popup sidebar-popup" : "toggle-popup"}>
      <div className="sidebar-layout custom-wizard">
        <div className='d-flex justify-content-end me-2'>
          <button className="sidebar-close close-btn-Wizard " onClick={closestepper}>
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="sidebar-header p-2">
          <>
            <h4>{isEditing ? `${actions?.label} Wizard` : `${actions?.label} Wizard`} </h4>
          </>
          <div className="submit-button text-end d-flex gap-2 align-items-center">

            <button
              className="btn btn-light"
              disabled={activeStep === 0}
              onClick={handleBack}
            >
              Back
            </button>
            <button
              disabled={(activeStep === 3 && parseFloat(remainingAmount.replace(/,/g, '')) !== 0) || !validateCurrentStep() || isLoadingStatus}
              className='btn btn-primary'
              onClick={handleNext}>
              {activeStep === steps?.length - 1 ? 'Save' : 'Next'}
            </button>
          </div>
        </div>
        <div className="toggle-body">
          <div className="toggle-height">
            {/* <form onSubmit={formikSales.handleSubmit}> */}
            <div className="pro-create">
              <Row>
                <Col>
                  <div className="Wizard">
                    <ul className="list-inline  d-flex justify-content-between mb-3 custom-width">
                      {(actions.value === 3 ? stepsPOH :
                        actions.value === 4 ? steps :
                          actions.value === 14 ? stepsResume :
                            actions.value === 13 ? stepsSpecReview :
                              actions.value === 12 ? stepsContractual :
                                actions.value === 36 ? stepsAcceptSale :
                                  actions.value === 15 ? stepsECDReviewed :
                                    actions.value === 37 ? stepsDRC :
                                      actions.value === 19 ? stepsDRCSignOff :
                                        actions.value === 21 ? stepsPCC :
                                          actions.value === 23 ? stepsPCCSignOff :
                                            actions.value === 25 ? stepsSendToPurchasing :
                                              actions.value === 27 ? stepsReadyForConstruction :
                                                actions.value === 30 ? stepsMarkInConstruction :
                                                  actions.value === 31 ? stepsMarkSubstantialComplete :
                                                    actions.value === 33 ? stepsMarkComplete :
                                                      actions.value === 2 ? stepsCancel :
                                                        actions.value === 6 ? stepsMarkAsDead :
                                                          actions.value === 5 ? stepsPromoteLeadToSw :
                                                            actions.value === 10 ? StepsRescind :
                                                              steps)?.map((label: any, index: any) => (
                                                                <React.Fragment key={label}>
                                                                  <li className={`list-inline-item me-0 ${activeStep === index ? 'active' : index < activeStep ? 'completed' : ''}`} >
                                                                    {label}
                                                                  </li>
                                                                  <li className='w-100'>
                                                                    <hr style={{ height: "2px", width: "100%" }} />
                                                                  </li>
                                                                  {/* {index < steps.length - 1 && ( )} */}
                                                                </React.Fragment>
                                                              ))}
                    </ul>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  {actions?.value === 4 ? getSalesContent(activeStep)
                    : actions?.value === 3 ? getPOHContent(activeStep)
                      : actions?.value === 14 ? getResumeContent(activeStep)
                        : actions?.value === 13 ? getSpecReview(activeStep)
                          : actions?.value === 12 ? getContractualReview(activeStep)
                            : actions?.value === 36 ? getAcceptedSale(activeStep)
                              : actions?.value === 15 ? ecdReviewed(activeStep)
                                : actions?.value === 37 ? drcWizardReviewed(activeStep)
                                  : actions?.value === 19 ? drcSignOff(activeStep)
                                    : actions?.value === 21 ? pccWizardReviewed(activeStep)
                                      : actions?.value === 23 ? pccSignOffWizardReviewed(activeStep)
                                        : actions?.value === 25 ? sendToPurchasingWizardReviewed(activeStep)
                                          : actions?.value === 27 ? readyForConstructionWizardReviewed(activeStep)
                                            : actions?.value === 30 ? markInConstructionWizardReviewed(activeStep)
                                              : actions?.value === 31 ? markSubstantialCompleteWizardReviewed(activeStep)
                                                : actions?.value === 33 ? markCompleteWizardReviewed(activeStep)
                                                  : actions?.value === 2 ? cancelWizardData(activeStep)
                                                    : actions?.value === 6 ? markAsDeadWizardData(activeStep)
                                                      : actions?.value === 5 ? promoteLeadToSW(activeStep)
                                                        : actions?.value === 10 ? rescindData(activeStep)
                                                          : ''
                  }
                </Col>
              </Row>
            </div>
            {/* </form> */}


          </div>
        </div>
      </div>
    </div>
  )

}

export default ActionWizard